import { JsonFormsRendererRegistryEntry } from '@jsonforms/core';
import {
  IonicDatePickerControl,
  IonicDatePickerTester,
} from './ionic-date-picker';
import {
  IonicHorizontalLayout,
  IonicHorizontalLayoutTester,
} from './ionic-horizontal-layout';
import { IonicLabelControl, IonicLabelTester } from './ionic-label';
import {
  IonicNumberInputControl,
  IonicNumberInputTester,
} from './ionic-number-input';
import { IonicPickerControl, IonicPickerTester } from './ionic-picker';
import { IonicRangeControl, IonicRangeTester } from './ionic-range';
import {
  IonicTextInputControl,
  IonicTextInputTester,
} from './ionic-text-input';

const ionicRenderers: JsonFormsRendererRegistryEntry[] = [
  { renderer: IonicTextInputControl, tester: IonicTextInputTester },
  { renderer: IonicNumberInputControl, tester: IonicNumberInputTester },
  { renderer: IonicDatePickerControl, tester: IonicDatePickerTester },
  { renderer: IonicPickerControl, tester: IonicPickerTester },
  { renderer: IonicLabelControl, tester: IonicLabelTester },
  { renderer: IonicRangeControl, tester: IonicRangeTester },
  { renderer: IonicHorizontalLayout, tester: IonicHorizontalLayoutTester },
];

export { ionicRenderers };
